module.exports = __webpack_public_path__ + "static/media/img-goal-6.45a2d44b.jpg";